(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6397"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6397"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d8HMG", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $990dfc566758140d$export$6503ec6e8aabbaf; }, function (v) { return $990dfc566758140d$export$6503ec6e8aabbaf = v; });
var $990dfc566758140d$export$6503ec6e8aabbaf;
var $990dfc566758140d$export$f7ad0328861e2f03;
"use strict";
var $990dfc566758140d$var$mapping = new Map();
function $990dfc566758140d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$990dfc566758140d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $990dfc566758140d$var$resolve(id) {
    var resolved = $990dfc566758140d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$990dfc566758140d$export$6503ec6e8aabbaf = $990dfc566758140d$var$register;
$990dfc566758140d$export$f7ad0328861e2f03 = $990dfc566758140d$var$resolve;

});

parcelRegister("3VV9c", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2dd306457558c0ef$export$bdfd709ae4826697; }, function (v) { return $2dd306457558c0ef$export$bdfd709ae4826697 = v; });
var $2dd306457558c0ef$export$bdfd709ae4826697;
var $2dd306457558c0ef$export$c9e73fbda7da57b6;
var $2dd306457558c0ef$export$5a759dc7a1cfb72a;
"use strict";
var $2dd306457558c0ef$var$bundleURL = {};
function $2dd306457558c0ef$var$getBundleURLCached(id) {
    var value = $2dd306457558c0ef$var$bundleURL[id];
    if (!value) {
        value = $2dd306457558c0ef$var$getBundleURL();
        $2dd306457558c0ef$var$bundleURL[id] = value;
    }
    return value;
}
function $2dd306457558c0ef$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2dd306457558c0ef$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2dd306457558c0ef$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2dd306457558c0ef$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2dd306457558c0ef$export$bdfd709ae4826697 = $2dd306457558c0ef$var$getBundleURLCached;
$2dd306457558c0ef$export$c9e73fbda7da57b6 = $2dd306457558c0ef$var$getBaseURL;
$2dd306457558c0ef$export$5a759dc7a1cfb72a = $2dd306457558c0ef$var$getOrigin;

});

parcelRegister("bo64b", function(module, exports) {
document.querySelector(".btn.btn-hamburger").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.remove("hide");
});
document.querySelector(".btn.navigationDrawer--closeBtn").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.add("hide");
});
document.querySelectorAll('[data-element="navItem-expander"]').forEach((el)=>{
    el.querySelector(".navigationDrawer--navItemBtn").addEventListener("click", (e)=>{
        if (el.querySelector(".navigationDrawer--navItemExpanded").classList.contains("hide")) {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.remove("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "180deg";
        } else {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.add("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "0deg";
        }
    });
});
document.addEventListener("DOMContentLoaded", ()=>{
    const hamburgerBtn = document.querySelector(".btn.btn-hamburger");
    const closeBtn = document.querySelector(".btn.navigationDrawer--closeBtn");
    const topNav = document.querySelector(".top-navigation");
    const drawer = document.querySelector(".navigationDrawer");
    // Open drawer → hide top nav, show drawer
    hamburgerBtn.addEventListener("click", ()=>{
        if (topNav) topNav.classList.add("d-none");
        if (drawer) drawer.classList.remove("d-none");
    });
    // Close drawer → show top nav, hide drawer
    closeBtn.addEventListener("click", ()=>{
        if (topNav) topNav.classList.remove("d-none");
        if (drawer) drawer.classList.add("d-none");
    });
});

});

parcelRegister("dUzBg", function(module, exports) {
const $a20c1ec3db67aafa$var$btnTopNavigationEls = document.querySelectorAll(".btn.link-item");
const $a20c1ec3db67aafa$var$navigationMegaDropdownEl = document.querySelector(".navigationMegaDropdown");






const $a20c1ec3db67aafa$var$setValueDropDownNavigation = (keyElement)=>{
    const dropdownNavigation = {
        services: [
            {
                pageUrl: "intelligent-finance.html",
                logoSrc: new URL((parcelRequire("fqo2Z"))),
                title: "Intelligent Finance Function"
            },
            {
                pageUrl: "manage-payroll.html",
                logoSrc: new URL((parcelRequire("lgkoL"))),
                title: "Managed Payroll"
            },
            {
                pageUrl: "consulting.html",
                logoSrc: new URL((parcelRequire("504W6"))),
                title: "Consulting"
            }
        ],
        products: [
            {
                pageUrl: "staflexx.html",
                logoSrc: new URL((parcelRequire("kfC9e"))),
                title: "Staflexx"
            },
            {
                pageUrl: "trakn.html",
                logoSrc: new URL((parcelRequire("l2nSp"))),
                title: "Trakn"
            },
            {
                pageUrl: "all-product.html",
                logoSrc: new URL((parcelRequire("dqo1Y"))),
                title: "All Product"
            }
        ]
    };
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn").forEach((el, index)=>index > 0 && el.remove());
    dropdownNavigation[keyElement].forEach((value)=>{
        const navigationMegaDropdownBtn = $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdownBtn").cloneNode(true);
        navigationMegaDropdownBtn.href = value.pageUrl;
        navigationMegaDropdownBtn.querySelector('[data-element="logoNavigation"]').src = value.logoSrc;
        navigationMegaDropdownBtn.querySelector('[data-element="titleNavigation"]').textContent = value.title;
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdown--inner").appendChild(navigationMegaDropdownBtn);
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn")[0].remove();
};
$a20c1ec3db67aafa$var$btnTopNavigationEls.forEach((el)=>{
    el.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
        $a20c1ec3db67aafa$var$setValueDropDownNavigation(el.getAttribute("data-element"));
    });
    el.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
});

});
parcelRegister("fqo2Z", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "battery-charging.ba1b1745.webp";

});

parcelRegister("lgkoL", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "settings-02.d69d69bd.webp";

});

parcelRegister("504W6", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "life-buoy.285e728c.webp";

});

parcelRegister("kfC9e", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "Staflexx_favicon.0afb56d6.webp";

});

parcelRegister("l2nSp", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "trakn_favicon.ffb5470c.webp";

});

parcelRegister("dqo1Y", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "box.2a34708a.webp";

});


parcelRegister("5iqNH", function(module, exports) {

var $8Ay3m = parcelRequire("8Ay3m");
const $3db36c35411957e8$var$testimonialCardParent = document.querySelector(".swiper-wrapper.testimonial-cards");
(0, $8Ay3m.default).forEach((testimonial)=>{
    const testimonialCardEl = document.querySelector('[data-element="testimonial-card-slider"]').cloneNode(true);
    testimonialCardEl.querySelector('[data-element="testimonial-people-name"]').textContent = testimonial.name;
    testimonialCardEl.querySelector('[data-element="testimonial-position"]').textContent = testimonial.position;
    testimonialCardEl.querySelector('[data-element="testimonial-text-all"]').innerHTML = testimonial.testimonyTextAll;
    testimonialCardEl.querySelector('[data-element="testimonial-text-less"]').innerHTML = testimonial.testimonyTextLess ?? testimonial.testimonyText;
    testimonialCardEl.querySelector('[data-element="testimonial-company-logo"]').src = testimonial.companyLogo;
    testimonialCardEl.querySelector('[data-element="testimonial-company-logo"]').parentElement.classList.add(testimonial.companyLogoClass);
    testimonialCardEl.querySelector('[data-element="testimonial-photo-small"]').srcset = testimonial.photo.mobile;
    testimonialCardEl.querySelector('[data-element="testimonial-photo-large"]').src = testimonial.photo.desktop;
    $3db36c35411957e8$var$testimonialCardParent.appendChild(testimonialCardEl);
});
document.querySelectorAll('[data-element="testimonial-card-slider"]')[0].remove();
document.querySelectorAll(".testimonial-content .showMoreBtn").forEach((el)=>{
    el.addEventListener("click", ()=>{
        const testimonialContent = el.parentElement.parentElement;
        testimonialContent.querySelector('[data-element="testimonial-text-all"]').style.display = "inline";
        testimonialContent.querySelector('[data-element="testimonial-text-less"]').style.display = "none";
    });
});
document.querySelectorAll(".testimonial-content .showLessBtn").forEach((el)=>{
    el.addEventListener("click", ()=>{
        const testimonialContent = el.parentElement.parentElement;
        testimonialContent.querySelector('[data-element="testimonial-text-all"]').style.display = "none";
        testimonialContent.querySelector('[data-element="testimonial-text-less"]').style.display = "inline";
    });
});

});
parcelRegister("8Ay3m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $640c19c59862cd3c$export$2e2bcd8739ae039; });




























const $640c19c59862cd3c$var$testimonials = [
    {
        name: "Neo Christodoulou",
        photo: {
            mobile: new URL((parcelRequire("b1YVJ"))),
            tablet: new URL((parcelRequire("bbnb8"))),
            desktop: new URL((parcelRequire("bbnb8")))
        },
        position: "Founder, Smashing Plates",
        companyLogo: new URL((parcelRequire("5lyKG"))),
        companyLogoClass: "smashing-plates",
        testimonyText: "Wenodo have been a long-standing close partner. Their holistic approach in managing our accounts has been invaluable to our organization. Not only do they handle all of our accounting needs, but they also expertly manage our HR/payroll department and also their customized cloud-based real-time analytics and reports has provided us with valuable insights and data-driven decision-making."
    },
    {
        name: "Johnny Smith and Daniel Willis",
        photo: {
            mobile: new URL((parcelRequire("1AMuf"))),
            tablet: new URL((parcelRequire("b80fq"))),
            desktop: new URL((parcelRequire("b80fq")))
        },
        position: "Co Founder, Luca Restaurant",
        companyLogo: new URL((parcelRequire("lMMvS"))),
        companyLogoClass: "luca",
        testimonyText: "Wenodo's team is exceptional! Their profound knowledge of the hospitality industry and their friendly customer service have been invaluable to our business. Their expertise in the intricacies of our industry coupled with their approachable and supportive service have made working with them a true pleasure. They understand our needs and offer tailored solutions, making a significant difference in our operations."
    },
    {
        name: "Wonchul Park",
        photo: {
            mobile: new URL((parcelRequire("gP6wd"))),
            tablet: new URL((parcelRequire("1bMkt"))),
            desktop: new URL((parcelRequire("1bMkt")))
        },
        position: "Michelin Star Chef, Sollip",
        companyLogo: new URL((parcelRequire("6suPO"))),
        companyLogoClass: "sollip",
        testimonyText: "Wenodo have been a long-standing close partner. Their holistic approach in managing our accounts has been invaluable to our organization. Not only do they handle all of our accounting needs, but they also expertly manage our HR/payroll department and also their customized cloud-based real-time analytics and reports has provided us with valuable insights and data-driven decision-making."
    },
    {
        name: "George\xa0Kakavitsa",
        photo: {
            mobile: new URL((parcelRequire("49UhS"))),
            tablet: new URL((parcelRequire("d1Dwb"))),
            desktop: new URL((parcelRequire("d1Dwb")))
        },
        position: "Assistant Restaurant Manager, L\xedo London",
        companyLogo: new URL((parcelRequire("eC5oP"))),
        companyLogoClass: "lio",
        testimonyText: "Wenodo's HR/Rota SaaS solution has revolutionized our workforce management. Its intuitive interface simplifies employee's lifecycle, shift scheduling and communication. With robust reporting, we gain valuable insights for informed decisions. Exceptional customer support ensures smooth operations. It's a game-changer for our Restaurant operation, enhancing efficiency and employee engagement. Highly recommended!"
    },
    {
        name: "Dominic Hamdy",
        photo: {
            mobile: new URL((parcelRequire("l8Pji"))),
            tablet: new URL((parcelRequire("40FxH"))),
            desktop: new URL((parcelRequire("40FxH")))
        },
        position: "Founder, HAM Restaurants",
        companyLogo: new URL((parcelRequire("jJBpI"))),
        companyLogoClass: "ham",
        testimonyText: "WENODO has helped to grow and streamline our business from day one. We can now make financial and strategic decisions based on data we can trust. Their personal attitude and enthusiasm to go the extra mile is invaluable, but it's their modern approach to accounting that has \xa0propelled us forward.\xa0"
    },
    // {
    //   name: 'Tarek Farah',
    //   photo: {
    //     mobile: new URL('../image/testimonial-tarek-farah-mobile.png?as=webp', import.meta.url),
    //     tablet: new URL('../image/testimonial-tarek-farah.png?as=webp', import.meta.url),
    //     desktop: new URL('../image/testimonial-tarek-farah.png?as=webp', import.meta.url)
    //   },
    //   position: 'Founder and CEO, Aline Lebanese Kitchen',
    //   companyLogo: new URL(
    //     '../image/aline-company.png',
    //     import.meta.url
    //   ),
    //   companyLogoClass: 'aline',
    //   testimonyText: 'I have been gladly working with the Wenodo team for nearly 10 years. They are not just professional, experienced, and knowledgeable accountants but also great consultants who offer so much value and advice on all levels of hospitality. I cannot imagine any of our future projects being developed without Wenodo by our side!'
    // },
    {
        name: "David Bellaiche",
        photo: {
            mobile: new URL((parcelRequire("3hO21"))),
            tablet: new URL((parcelRequire("fBmFs"))),
            desktop: new URL((parcelRequire("fBmFs")))
        },
        position: "Co-Founder, NAC London",
        companyLogo: new URL((parcelRequire("ZUKbB"))),
        companyLogoClass: "nac",
        testimonyText: "Wenodo's daily, weekly, and monthly KPIs and analytics has been so critical for our business. Their insightful Dashboard and reports have allowed us to maximize profits. With these detailed metrics, we're empowered to make timely and informed decisions, contributing significantly to\xa0our\xa0success."
    },
    {
        name: "Gabriel Cohen-Elia",
        photo: {
            mobile: new URL((parcelRequire("1YaD3"))),
            tablet: new URL((parcelRequire("3yfq8"))),
            desktop: new URL((parcelRequire("3yfq8")))
        },
        position: "Co-Founder, Cr\xe8me London",
        companyLogo: new URL((parcelRequire("2Nsy2"))),
        companyLogoClass: "creme",
        testimonyText: "Partnering with Wenodo has revolutionized how we manage our finances and operations. Their specialized accounting and bookkeeping solutions have not only streamlined our processes but also brought unparalleled clarity to our financial landscape. Wenodo's dedicated support team is always responsive and knowledgeable, making them an integral part of our success. For anyone in hospitality seeking reliability and expertise, Wenodo is the\xa0clear\xa0choice."
    }
];
var $640c19c59862cd3c$export$2e2bcd8739ae039 = $640c19c59862cd3c$var$testimonials;

});
parcelRegister("b1YVJ", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimoni-neo-mobile.63e4b5d3.webp";

});

parcelRegister("bbnb8", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimoni-neo.dcffeccd.webp";

});

parcelRegister("5lyKG", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "smashing-plates.7136aa41.webp";

});

parcelRegister("1AMuf", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimoni-johny-mobile.dfee8b00.webp";

});

parcelRegister("b80fq", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimoni-johny.331dada6.webp";

});

parcelRegister("lMMvS", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "luca-company.ebbca258.webp";

});

parcelRegister("gP6wd", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimonial-wonchul-mobile.82623782.webp";

});

parcelRegister("1bMkt", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimonial-wonchul.e435ed72.webp";

});

parcelRegister("6suPO", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "sollip-company.c4e68d8a.png";

});

parcelRegister("49UhS", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimonial-george-mobile.ba4357c1.webp";

});

parcelRegister("d1Dwb", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimonial-george.3f5b8295.webp";

});

parcelRegister("eC5oP", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "lio-company.51d21251.png";

});

parcelRegister("l8Pji", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimonial-dominic-hamdy-mobile.795bc261.webp";

});

parcelRegister("40FxH", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimonial-dominic-hamdy.7a029c2b.webp";

});

parcelRegister("jJBpI", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "ham-company.5f8ce858.png";

});

parcelRegister("3hO21", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimonial-david-bellaiche-mobile.c3669d3d.webp";

});

parcelRegister("fBmFs", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimonial-david-bellaiche.e487dcaf.webp";

});

parcelRegister("ZUKbB", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "nac-company.269e0029.png";

});

parcelRegister("1YaD3", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimonial-gabriel-mobile.45a97971.webp";

});

parcelRegister("3yfq8", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "testimonial-gabriel.ad41ee07.webp";

});

parcelRegister("2Nsy2", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("e0IEx") + "creme-company.ca71e074.png";

});



parcelRegister("2SvjK", function(module, exports) {
const $2188eaecfbdd828c$var$preferencePrivacyPopupEl = document.querySelector(".preferencePrivacy-popup");
const $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl = document.querySelector(".preferencePrivacy-popupDetail");
const $2188eaecfbdd828c$var$isCookies = document.cookie.split(";").filter((value)=>value === "_cookies=guest")[0] === "_cookies=guest" || document.cookie.split(";").filter((value)=>value === " _cookies=guest")[0] === " _cookies=guest";
if ($2188eaecfbdd828c$var$isCookies) $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
else $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// Cookies Button
document.querySelector(".btn-cookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// document.querySelector('.cookies-alert-popup').style.display = 'block'
});
document.querySelector(".cookies-accept-btn").addEventListener("click", ()=>{
    // document.querySelector('.cookies-alert-popup').style.display = 'none'
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.preferencePrivacy-popup--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.add("show");
// document.cookie = '_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC'
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
document.querySelector(".btn.cookies-learn-more-btn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
    document.querySelector(".cookies-alert-popup").style.display = "none";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.preferencePrivacy-popupDetail--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--preferencePrivacy-popupDetailConfirmPreference").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});

});

var $7c80a78881c17d40$exports = {};


(parcelRequire("d8HMG")).register((parcelRequire("3VV9c")).getBundleURL("e0IEx"), JSON.parse('["e0IEx","staflexx.69e83502.js","giQtv","battery-charging.ba1b1745.webp","23FFC","settings-02.d69d69bd.webp","eQ5EQ","life-buoy.285e728c.webp","dHV0l","Staflexx_favicon.0afb56d6.webp","cmPFA","trakn_favicon.ffb5470c.webp","9Glg9","box.2a34708a.webp","8XsBo","testimoni-neo-mobile.63e4b5d3.webp","4ho8f","testimoni-neo.dcffeccd.webp","hLnjK","smashing-plates.7136aa41.webp","lORrT","testimoni-johny-mobile.dfee8b00.webp","5pWvc","testimoni-johny.331dada6.webp","e7lNY","luca-company.ebbca258.webp","cDWBZ","testimonial-wonchul-mobile.82623782.webp","3V7nb","testimonial-wonchul.e435ed72.webp","jp2ug","sollip-company.c4e68d8a.png","3v0AM","testimonial-george-mobile.ba4357c1.webp","991Ub","testimonial-george.3f5b8295.webp","3ZUyT","lio-company.51d21251.png","cqGH0","testimonial-dominic-hamdy-mobile.795bc261.webp","3WiP9","testimonial-dominic-hamdy.7a029c2b.webp","eba0Q","ham-company.5f8ce858.png","e5FYN","testimonial-david-bellaiche-mobile.c3669d3d.webp","iQoFg","testimonial-david-bellaiche.e487dcaf.webp","isBg7","nac-company.269e0029.png","7yGuJ","testimonial-gabriel-mobile.45a97971.webp","774bJ","testimonial-gabriel.ad41ee07.webp","tTeKh","creme-company.ca71e074.png"]'));

parcelRequire("bo64b");
parcelRequire("dUzBg");
parcelRequire("5iqNH");
parcelRequire("2SvjK");
/* eslint-disable no-undef */ // eslint-disable-next-line no-unused-vars
const $23fa955a49398ed0$var$swiper = new Swiper(".swiper-testimonial", {
    // Optional parameters
    // direction: 'vertical',
    loop: false,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 32,
    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination'
    // },
    // Navigation arrows
    navigation: {
        nextEl: ".swiper-testimonial-next-button",
        prevEl: ".swiper-testimonial-prev-button"
    },
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar'
    // }
    breakpoints: {
        1200: {
            slidesPerView: 1.2
        }
    }
});
const $23fa955a49398ed0$var$isLarge = window.matchMedia("(min-width: 1200px)");
if ($23fa955a49398ed0$var$isLarge.matches) // Then trigger an alert
$23fa955a49398ed0$var$swiper.on("slideChange", function() {
    if ($23fa955a49398ed0$var$swiper.activeIndex === 0) document.querySelector(".swiper-wrapper.testimonial-cards").style.left = "-8.25%";
    else if ($23fa955a49398ed0$var$swiper.activeIndex === 1) {
        document.querySelector(".swiper-wrapper.testimonial-cards").style.left = "auto";
        document.querySelector(".swiper-wrapper.testimonial-cards").style.right = "auto";
    } else if ($23fa955a49398ed0$var$swiper.activeIndex === 2) document.querySelector(".swiper-wrapper.testimonial-cards").style.right = "-8.25%";
});
const $23fa955a49398ed0$var$servicePreHeadingIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="#1DCA5D"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8337 14.2283C13.2713 13.8583 14.3337 12.5532 14.3337 11C14.3337 9.15905 12.8413 7.66667 11.0003 7.66667C9.15938 7.66667 7.66699 9.15905 7.66699 11C7.66699 12.5532 8.7293 13.8583 10.167 14.2283V23.5C10.167 23.9602 10.5401 24.3333 11.0003 24.3333C11.4606 24.3333 11.8337 23.9602 11.8337 23.5V14.2283Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.667 21C17.667 19.4468 18.7293 18.1417 20.167 17.7717V12.6667C20.167 12.4457 20.0792 12.2337 19.9229 12.0774C19.7666 11.9211 19.5547 11.8333 19.3337 11.8333H16.8337C16.3734 11.8333 16.0003 11.4602 16.0003 11C16.0003 10.5398 16.3734 10.1667 16.8337 10.1667H19.3337C19.9967 10.1667 20.6326 10.4301 21.1014 10.8989C21.5703 11.3677 21.8337 12.0036 21.8337 12.6667V17.7717C23.2713 18.1417 24.3337 19.4468 24.3337 21C24.3337 22.8409 22.8413 24.3333 21.0003 24.3333C19.1594 24.3333 17.667 22.8409 17.667 21Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21C17.6667 19.4468 18.729 18.1417 20.1667 17.7717V12.6667C20.1667 12.4457 20.0789 12.2337 19.9226 12.0774C19.7663 11.9211 19.5543 11.8333 19.3333 11.8333H16.8333C16.3731 11.8333 16 11.4602 16 11C16 10.5398 16.3731 10.1667 16.8333 10.1667H19.3333C19.9964 10.1667 20.6323 10.4301 21.1011 10.8989C21.5699 11.3677 21.8333 12.0036 21.8333 12.6667V17.7717C23.271 18.1417 24.3333 19.4468 24.3333 21C24.3333 22.8409 22.8409 24.3333 21 24.3333C19.1591 24.3333 17.6667 22.8409 17.6667 21Z" fill="#77DF9E"/>
</svg>`;
document.querySelector(".apps__human-resource--left-preHeading-icon").innerHTML += $23fa955a49398ed0$var$servicePreHeadingIcon;
document.querySelector(".testimonial-slider-preHeading .services__icon").innerHTML += $23fa955a49398ed0$var$servicePreHeadingIcon;
document.querySelector(".faq__feature-consulting--preHeading-icon").innerHTML += $23fa955a49398ed0$var$servicePreHeadingIcon;
// Arrow Up Icon Button
const $23fa955a49398ed0$var$arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".btn.btn-talk-us").forEach((el)=>{
    el.innerHTML += $23fa955a49398ed0$var$arrowUpIcon;
    el.setAttribute("onclick", "location.href = 'contact-us.html';");
});
// document.querySelector('.btn-learn-more').innerHTML += arrowUpIcon
document.querySelector(".btn.btn-book-demo").innerHTML += $23fa955a49398ed0$var$arrowUpIcon;
// FAQ
document.querySelectorAll(".faq__feature-consulting--faqItem").forEach((el)=>{
    el.querySelector(".faq__feature-consulting--faqItem-header").addEventListener("click", ()=>{
        if (el.classList.contains("active")) el.classList.remove("active");
        else {
            document.querySelectorAll(".faq__feature-consulting--faqItem").forEach((el2)=>{
                el2.classList.remove("active");
            });
            el.classList.add("active");
        }
    });
});
const $23fa955a49398ed0$var$chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".link-item .arrow-down").forEach((el)=>{
    el.innerHTML += $23fa955a49398ed0$var$chevronDownIcon;
});
const $23fa955a49398ed0$var$hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelector(".btn-hamburger").innerHTML += $23fa955a49398ed0$var$hamburgerIcon;
// Create the observer like the examples above
const $23fa955a49398ed0$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) entry.target.classList.add("animate__fadeInUp");
    // entry.target.classList.remove('animate__animated')
    });
});
// Get multiple elements instead of a single one using "querySelectorAll"
const $23fa955a49398ed0$var$squares = document.querySelectorAll(".animated-js");
// Loop over the elements and add each one to the observer
$23fa955a49398ed0$var$squares.forEach((element)=>$23fa955a49398ed0$var$observer.observe(element));

})();
//# sourceMappingURL=staflexx.69e83502.js.map
